import DeleteIcon from '@mui/icons-material/Delete';
import { Button } from '@mui/material';
import GridReal from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';

import { type AggregateFile, AggregateService } from '~/services/aggregate';
import { Roles } from '~/types/types';

export const AggregateRoles: Readonly<Roles[]> = [Roles.Import];

const Grid = ({ children, ...props }: {[_x: string]: any, children: any}) => (
  <GridReal {...props} style={{ padding: 4 }}>
    {children}
  </GridReal>
);

const AggregateList = (props: any) => {
  const [aggregateFiles, setAggregateFiles] = useState([]);
  const [updated, setUpdated] = useState(false);

  useEffect(() => {
    const subscription = AggregateService.getAggregateFiles().subscribe((data: any) => {
      setAggregateFiles(data);
    });

    return () => subscription.unsubscribe();
  }, [updated]);

  const removeAggregate = (aggregateFile: any) => {
    if (!confirm('Är du säker?')) {
      return;
    }

    AggregateService.delete(aggregateFile.id).subscribe(() => setUpdated(!updated));
  };

  const useStyles = makeStyles()({
    deleteIcon: {
      padding: '4px',
    },
    table: {
      width: '100%',
    },
  });

  const { classes } = useStyles();

  const deleteOrInQueue = (aggregateFile: any) => {
    if (aggregateFile.inQueue) {
      return (
        <>
          Behandlas i <Link to="/imports">importkön</Link>
        </>
      );
    }

    return (
      <IconButton className={classes.deleteIcon} onClick={() => removeAggregate(aggregateFile)} size="large">
        <DeleteIcon titleAccess="Delete" color={'action'} />
      </IconButton>
    );
  };

  return (
    <Table className={classes.table}>
      <TableHead>
        <TableRow>
          <TableCell>Datum</TableCell>
          <TableCell>Användarnamn</TableCell>
          <TableCell>Filidentitet</TableCell>
          <TableCell>Submissionsår</TableCell>
          <TableCell></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {aggregateFiles.map((aggregateFile: AggregateFile, index) => {
          return (
            <TableRow key={index}>
              <TableCell>{aggregateFile.created.split('.')[0].replace('T', ' ')}</TableCell>
              <TableCell>{aggregateFile.principalName}</TableCell>
              <TableCell>
                <a
                  href={'/api/aggregates/' + aggregateFile.id}
                  download={aggregateFile.fileIdentity + '_' + aggregateFile.submissionYear + '.xlsx'}
                >
                  {aggregateFile.fileIdentity}
                </a>
              </TableCell>
              <TableCell>{aggregateFile.submissionYear}</TableCell>
              <TableCell>{deleteOrInQueue(aggregateFile)}</TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};

export default function AggregatePage(_props: any) {
  return (
    <>
      <Grid container item xs={12} lg={10} spacing={2}>
        <Grid item>
          <Typography variant="h4">Aggregat</Typography>
          <Typography>
            Notera att den här sidan uppdateras automatiskt en gång per minut. Om ett aggregat tas bort så skapas ett
            arbete i importkön för att rensa och sedan köra aggregeringen på nytt. Klicka på länken under{' '}
            <b>Filidentitet</b> för att ladda ner aggregatfilen.
          </Typography>
        </Grid>
      </Grid>

      <Grid container item xs={12} lg={10} spacing={2}>
        <Grid item>
          <Button variant="contained" color={'primary'} href="/import">
            Importera fil
          </Button>
        </Grid>
      </Grid>

      <Grid container item xs={12} lg={10} spacing={2}>
        <Grid item>
          <Typography variant="h4">Aggregatfiler</Typography>
          <AggregateList />
        </Grid>
      </Grid>
    </>
  );
}
